import React, { useState, useEffect, useRef } from "react"
import styles from "./NumberBox.module.css"
import { CanvasCell } from "../../Model/types"

interface NumberBoxProps {
    data: CanvasCell
    onDoneEditing: (fieldName: string, newValue: number) => void
    canEdit: boolean
}

const NumberBox: React.FC<NumberBoxProps> = ({ data, onDoneEditing, canEdit }) => {
    const [value, setValue] = useState<number>(data.value as number)
    const [isFocused, setIsFocused] = useState<boolean>(false)
    const textareaRef = useRef<HTMLTextAreaElement | null>(null)

    useEffect(() => {
        setValue(data.value as number)
    }, [data.value])

    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"
            textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
        }
    }, [value, canEdit])

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setValue(parseInt(e.target.value))
    }

    const handleBlur = () => {
        setIsFocused(false)
        if (value !== data.value) {
            onDoneEditing(data.fieldName, value)
        }
    }

    const handleFocus = () => {
        setIsFocused(true)
    }

    const formattedValue = value?.toLocaleString() ?? "0"
    const displayValue = isFocused ? value : `$${formattedValue}`

    const textBox = canEdit ? (
        <textarea
            ref={textareaRef}
            className={styles.textInput}
            value={isFocused ? value : displayValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            rows={1} // Start with one row
        />
    ) : (
        <div className={styles.textInput}>${formattedValue}</div>
    )

    return textBox
}

export default NumberBox
